// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

// 获取本地数据
import "@/service/index.js"

// import '@/components/index' // 全局组件
import '@/plugins/pluginsIndex' // 第三方组件
// import '@/assets/styles/styleIndex' // 公用css
// import BaiduMap from 'vue-baidu-map' //百度地图
import '@/utils/common' // 公用函数
import 'default-passive-events'
// import vshare from 'vshare'

// Vue.use(vshare);

//vue 滚动插件
// import scroll from 'vue-seamless-scroll';
// Vue.use(scroll);

// md5加密
// import md5 from 'js-md5';
// Vue.prototype.$md5 = md5;
// //百度地图appkey
// Vue.use(BaiduMap, {
//   ak: 'gjjUF1pMfxxGC0mLwDFORDKxqdZ05AYW'
// });
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

/*router.beforeEach((to,from,next)=>{
  if(to.meta.loginRequest){ // 如果路由 中的 meta loginQeuest 为true 进行拦截 即 需要登录操作的页面
    console.log("token=",sessionStorage.getItem("token"));
    if(sessionStorage.getItem("token")){
      next(); // 如果已登录 直接进入页面
    }else { // 跳转到登录页 带上一页的url
      next({
        path: '/logon',
        query:{
          redirect: to.fullPath // 把要跳转的页面传到登录页面
      }});
    }
  }
})*/



// WEBPACK FOOTER //
// ./src/main.js